import {ValueObject} from '@s-ui/domain'

export class TrackingPhoneDealerValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} data
   * @param {string} data.sessionId
   * @param {string} data.phoneNumber
   */

  getSessionId() {
    return this._sessionId
  }

  getTrackingId() {
    return this._trackingId
  }
}
